import { AbnormalFilter } from "../types/common.types";
import { SurgeriesChecklist, SurgeryManagment } from "../types/surgeries.types";
import { baseHttp } from "./baseHttp";

const getSurgeries = async (
  payload: AbnormalFilter[]
): Promise<SurgeryManagment[]> => {
  return baseHttp
    .post(
      `/api/n/surgery-management/monitor/filter?q=1&page=1&take=1000&order=data.admissionDate:ASC`,
      payload
    )
    .then((response) => response.data.list);
};

const getChecklistExist = async (uuid: string): Promise<SurgeriesChecklist> => {
  return baseHttp
    .get(`/api/n/surgery-management/checklists/exist/${uuid}`)
    .then((response) => response.data);
};

const getPatientByNosological = async (
  nosological: string
): Promise<Record<string, any>> => {
  return baseHttp
    .post(`/api/n/nosological/filter?page=1&take=1000`, [{
      value: nosological,
      field: "t.code",
      operator: "equal",
    }])
    .then((response) => response.data.list?.[0]);
};

const getSurgeryByNosological = async (
  patientUUID: string
): Promise<Record<string, any>> => {
  return baseHttp
    .post(
      `/api/n/surgery-management/monitor/filter?q=1&page=1&take=1&order=t.createdAt:DESC`,
      [{
        value: patientUUID,
        field: "patient.uuid",
        operator: "equal",
      }]
    )
    .then((response) => response.data.list?.[0]);
};

const getSurgeryRequestUuid = async (
  SurgeryManagmentUuid: string
): Promise<Record<string, any>> => {
  return baseHttp
    .get(
      `/api/n/surgery-management/${SurgeryManagmentUuid}/surgery-request`)
    .then((response) => response.data);
};

const getSurgeryRequestRevisionUuid = async (
  SurgeryRequestUuid: string
): Promise<Record<string, any>> => {
  return baseHttp
    .get(
      `/api/n/surgery-request/${SurgeryRequestUuid}`)
    .then((response) => response.data);
};

const SurgeryService = {
  getSurgeries,
  getChecklistExist,
  getSurgeryByNosological,
  getPatientByNosological,
  getSurgeryRequestUuid,
  getSurgeryRequestRevisionUuid,
};

export default SurgeryService;
